module.exports = __webpack_public_path__ + "img/FrC8KZ2XgAA1P_K.fb0e1014.jpeg";